import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.posterImage}
          alt={`${movie.title} ${movie.originalTitle} 电影海报`}
          title={`${movie.title} - ${movie.originalTitle}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          width="600"
          height="900"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">
          {movie.rating}
        </div>
        {movie.resolution === '蓝光4K' && (
          <div className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">
            4K
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{movie.originalTitle}</p>
        <div className="flex items-center gap-2 mt-2 flex-wrap">
          <span className="text-xs text-foreground-400 whitespace-nowrap">{movie.year}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{movie.duration}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{movie.resolution}</span>
        </div>
        <div className="flex gap-1.5 mt-2 flex-wrap">
          {movie.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}